import React, { useContext } from 'react'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import FourOptions from '../FourOptions'
import StepCounter from '../StepCounter'

import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import gif5 from './assets/05_card 2.gif'
import jpg5 from './assets/static/05_card-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q5() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif5" src={settings.isAnimationPause ? jpg5 : gif5} />
            </div>
            <Headling text={translate('Swipe Right')} />
            <Subtitle text={translate('How many bank cards are there in my household?')} />
            <FourOptions 
                option1={translate('One card')}
                option2={translate('Two cards')}
                option3={translate('Three cards')}
                option4={translate('Four cards or more')} 
                onOption1Press={() => {
                    setNewAnswer({ 5: 1 } )
                    history.push('/Q/6')
                    ReactPixel.trackCustom('one_card', '');
                }}
                onOption2Press={() => {
                    setNewAnswer({ 5: 2 })
                    history.push('/Q/6')
                    ReactPixel.trackCustom('two_card', '');
                }}
                onOption3Press={() => {
                    setNewAnswer({ 5: 3  })
                    history.push('/Q/6')
                    ReactPixel.trackCustom('three_card', '');
                }}
                onOption4Press={() => {
                    setNewAnswer({ 5: 4  })
                    history.push('/Q/6')
                    ReactPixel.trackCustom('four_card', '');
                }}
            />
            <StepCounter />

        </>
    )
}



export default Q5

